;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .factory('IconService', iconService)

  /* @ngInject */
  function iconService (ConnectorWebService, CONSTANTS, Utils) {
    var aCategories = []

    var service = {
      getIcons: getIcons,
      getIconsByCategory: getIconsByCategory,
      fnSearchForIcons: fnSearchForIcons,
      fnSetCategories: fnSetCategories,
      getIconCategories: getIconCategories
    }

    return service

    function mapGetResponse (oRes) {
      if (!oRes.d) {
        oRes.d = { results: oRes }
      }

      var aResults = oRes.d.results.map(function (oIcon) {
        if (!oRes.d) {
          oRes.d = { results: oRes }
        }

        return {
          id: oIcon.id,
          categoryId: oIcon.categoryId,
          createdAt: oIcon.createdAt,
          updatedAt: oIcon.updatedAt,
          src: {
            original: oIcon.svg,
            thumbnail: oIcon.img
          }
        }
      })

      oRes.d.results = aResults

      return oRes
    }

    function getIcons (iTop, iSkip) {
      var sUrl = Utils.fnAddTopSkipQueriesToUrl(CONSTANTS.URL_ICONS, iTop, iSkip)

      return ConnectorWebService.get(sUrl).then(mapGetResponse)
    }

    function getIconsByCategory (iCategoryId) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_ICONS_BY_CATEGORY, [iCategoryId])

      return ConnectorWebService.get(sUrl).then(mapGetResponse)
    }

    function fnSearchForIcons (sSearchParam) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_ICONS_SEARCH, [sSearchParam])

      return ConnectorWebService.get(sUrl).then(mapGetResponse)
    }

    function fnSetCategories (aCategories) {
      aCategories = aCategories.slice()
    }

    function getIconCategories (fnSuccessCallback, fnErrorCallback) {
      if (aCategories.length > 0 && fnSuccessCallback) {
        fnSuccessCallback(aCategories)
        return
      }

      if (fnSuccessCallback) {
        ConnectorWebService.get(CONSTANTS.URL_ICON_CATEGORIES)
          .then(function (res) {
            fnSetCategories(res.d.results)

            fnSuccessCallback(res.d.results)
          }, function (error) {
            if (fnErrorCallback) {
              fnErrorCallback(error)
            }
          })

        return
      }

      return null
    }
  }
})()
